import { createSlice } from "@reduxjs/toolkit";

const structureFieldsSlice = createSlice({
  name: "structureFields",
  initialState: {
    filters: {},
  },
  reducers: {
    updateFilters: {
      reducer(state, { payload }) {
        state.filters = { ...state.filters, ...payload };
      },
    },
  },
});

const { actions, reducer } = structureFieldsSlice;

export const { updateFilters } = actions;

export default reducer;
